import axios, { AxiosResponse } from 'axios'
import { useDispatch } from 'react-redux'
import {
  updateCustomerGroupId,
  updateShopAccess,
  updateShopAccessKey,
  updateShopAuthToken,
  updateShopChannelId,
  updateShopLanguage,
} from 'src/State/Shop/ShopAction'
import { ShopLanguageResponse } from '../models'

interface ShopLoginResponse {
  contextToken: string
  customerGroupId?: string
  swAccessKey: string
  salesChannelId: string
}

/*
 * This Hook Is Created to Request to Log In into the Shop with the current user. Based on Portal Token.
 * It also Request the Language from the Shop Based on the Portal Language
 */

function useShopLogin(): {
  shopLogin: (portalToken: string) => Promise<void>
  fetchShopLanguage: (token: string, shopAccessKey?: string) => Promise<void>
} {
  const dispatch = useDispatch()
  const shopLogin = async (portalToken: string): Promise<void> => {
    try {
      const result: AxiosResponse<ShopLoginResponse> = await axios.post(
        `${process.env.REACT_APP_SHOP_API_ENDPOINT}/e3dc/login`,
        { portalToken },
        {
          headers: {
            'sw-access-key': process.env.REACT_APP_SHOP_API_ACCESS_KEY,
          },
        }
      )

      if (result.data.contextToken) {
        dispatch(updateShopAuthToken(result.data.contextToken))
        dispatch(updateCustomerGroupId(result.data?.customerGroupId ?? null))
        dispatch(updateShopAccessKey(result.data.swAccessKey))
        dispatch(updateShopChannelId(result.data.salesChannelId))

        await fetchShopLanguage(result.data.contextToken, result.data.swAccessKey)
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error)
      }

      throw error
    }
  }

  const fetchShopLanguage = async (token: string, shopAccessKey?: string): Promise<void> => {
    try {
      const result: AxiosResponse<ShopLanguageResponse> = await axios.post(
        `${process.env.REACT_APP_SHOP_API_ENDPOINT}/language`,
        { includes: { language: ['id', 'name'] } },
        {
          headers: {
            'sw-access-key': shopAccessKey ?? process.env.REACT_APP_SHOP_API_ACCESS_KEY,
            'sw-context-token': token,
          },
        }
      )
      dispatch(updateShopLanguage(result.data.elements))
      dispatch(updateShopAccess(true))
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log(error)
      }
    }
  }

  return { shopLogin, fetchShopLanguage }
}

export default useShopLogin
